import {
  alertMessagesArgsConfig,
  browserStorageAndConsoleArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  dataOperationTypeArgsConfig,
  deliveryMethodServicePluginArgsConfig,
  getItemIdFromArgsConfig,
  otpAuthenticationTypeArgsConfig,
  redirectUrlArgsConfig,
  userRoleArgsConfig,
} from '../../utils/event_constants';

export const otpAuthenticatorActions = [
  {
    name: 'generateEmailOTP',
    label: 'Generate OTP and Send Email',
    args: [
      otpAuthenticationTypeArgsConfig,
      userRoleArgsConfig({ name: 'role' }),
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      deliveryMethodServicePluginArgsConfig('email'),
      {
        name: 'emailTemplate',
        label: 'Select Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
      ...browserStorageAndConsoleArgsConfig,
    ],
  },
  {
    name: 'generateOnlyEmailOTP',
    label: 'Generate Email OTP',
    args: [
      otpAuthenticationTypeArgsConfig,
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'verifyEmailOTP',
    label: 'Verify Email OTP and Login',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'generateSmsOTP',
    label: 'Generate OTP and Send SMS',
    args: [
      otpAuthenticationTypeArgsConfig,
      userRoleArgsConfig({ name: 'role' }),
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      deliveryMethodServicePluginArgsConfig('sms'),
      {
        name: 'smsTemplate',
        label: 'Select SMS Template',
        type: 'dropdown',
        optionsType: 'smsTemplateApi',
        options: [],
        value: '',
      },
      {
        name: 'dltTemplateId',
        label: 'Enter DLT Template ID (if using Parken)',
        type: 'text',
        value: '',
      },
      {
        name: 'smsType',
        label: 'Select SMS Type (if using Parken)',
        type: 'dropdown',
        optionsType: 'smsTypeApi',
        options: [
          { value: '1', label: 'Transactional' },
          { value: '2', label: 'Sender ID' },
          { value: '3', label: 'Promotional' },
          { value: '4', label: 'Trans OTP' },
          { value: '5', label: 'Promo Tran' },
          { value: '6', label: 'SIMBASE' },
          { value: '7', label: 'SIMBAS' },
          { value: '9', label: 'SMBASE' },
          { value: '10', label: 'Defaultsfac' },
          { value: '11', label: 'BSNLTRA' },
          { value: '12', label: 'International' },
        ],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'fromNumberField', label: 'From Number Field' }),
      ...alertMessagesArgsConfig,
      ...browserStorageAndConsoleArgsConfig,
    ],
  },
  {
    name: 'generateOnlySMSOTP',
    label: 'Generate SMS OTP',
    args: [
      otpAuthenticationTypeArgsConfig,
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'verifySmsOTP',
    label: 'Verify SMS OTP and Login',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'generateUserConsentEmailOTP',
    label: 'Generate User Consent OTP and Send Email',
    args: [
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'emailTemplate',
        label: 'Select Email Template',
        type: 'dropdown',
        optionsType: 'emailTemplateApi',
        options: [],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'userEmailField', label: 'Select User Email Field' }),
      deliveryMethodServicePluginArgsConfig('email'),
      collectionArgsConfig,
      dataOperationTypeArgsConfig,
      {
        name: 'getItemIdFrom',
        label: 'Get User Id From',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: 'loggedInUserId',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'generateOnlyUserConsentEmailOTP',
    label: 'Generate User Consent Email OTP',
    args: [
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      collectionArgsConfig,
      dataOperationTypeArgsConfig,
      {
        name: 'getItemIdFrom',
        label: 'Get Item Id From for Update',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'verifyUserConsentEmailOTP',
    label: 'Verify Email Consent OTP and Save Data',
    args: [
      collectionArgsConfig,
      ...redirectUrlArgsConfig,
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'generateUserConsentSmsOTP',
    label: 'Generate User Consent OTP and Send SMS',
    args: [
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'smsTemplate',
        label: 'Select SMS Template',
        type: 'dropdown',
        optionsType: 'smsTemplateApi',
        options: [],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'userMobileField', label: 'User Phone Number Field' }),
      deliveryMethodServicePluginArgsConfig('sms'),
      {
        name: 'dltTemplateId',
        label: 'Enter DLT Template ID',
        type: 'text',
        value: '',
      },
      {
        name: 'smsType',
        label: 'Select SMS Type',
        type: 'dropdown',
        optionsType: 'smsTypeApi',
        options: [
          { value: '1', label: 'Transactional' },
          { value: '2', label: 'Sender ID' },
          { value: '3', label: 'Promotional' },
          { value: '4', label: 'Trans OTP' },
          { value: '5', label: 'Promo Tran' },
          { value: '6', label: 'SIMBASE' },
          { value: '7', label: 'SIMBAS' },
          { value: '9', label: 'SMBASE' },
          { value: '10', label: 'Defaultsfac' },
          { value: '11', label: 'BSNLTRA' },
          { value: '12', label: 'International' },
        ],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'fromNumberField', label: 'From Number Field' }),
      collectionArgsConfig,
      dataOperationTypeArgsConfig,
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'generateOnlyUserConsentSmsOTP',
    label: 'Generate User Consent SMS OTP',
    args: [
      {
        name: 'otpVerificationPage',
        label: 'Select OTP Authenticator Component Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      collectionArgsConfig,
      dataOperationTypeArgsConfig,
      {
        name: 'getItemIdFrom',
        label: 'Get Item Id From for Update',
        type: 'dropdown',
        optionsType: 'getItemIdFromApi',
        value: '',
      },
      {
        name: 'browserStorageLocation',
        label: 'Session Storage Location (Optional)',
        type: 'browserStorageLocation',
        optionsType: 'browserStorageLocationOptionsApi',
        options: [],
        value: 'SESSION_STORAGE',
      },
      {
        name: 'browserStorageItemIdPath',
        label: 'Browser Storage Key',
        type: 'text',
        placeholder: 'Item Id Path (ex. sessionKey.uuid)',
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'verifyUserConsentSmsOTP',
    label: 'Verify SMS Consent OTP and Save Data',
    args: [
      collectionArgsConfig,
      ...redirectUrlArgsConfig,
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
];
